import React from 'react';
import { object } from 'prop-types';
import { LOGS_KEY } from '../utils/constants';
import { logger } from '../shared/logger';

export const withPropsValidation = (validate) => (WrappedComponent) => {
    const Validator = function WithPropsValidation(props) {
        try {
            validate(props);

            return <WrappedComponent {...props} />;
        } catch (e) {
            const componentName = props.requestContext && props.requestContext.componentName;

            logger.error(e, {
                componentName,
                componentProps: JSON.stringify(props),
                [LOGS_KEY]: 'Component props are invalid',
            });

            return null;
        }
    };

    Validator.propTypes = {
        requestContext: object,
    };

    return Validator;
};
